package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_05_24_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis uses animal message to")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Inform The Grove that he will be joining the Friends of the Forest on their epic quest")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Warn the people of Seshiss that the immediate threat has been neutralized but the aboleth survived")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday draws a circle on the ground, inscribed with sigils, opening a portal to Bondōvriar. The heroes jump through, startling a jumpy nerd, who runs away. At the top of the stairs, they see Zordifraz Gribblehook. They tell Zordie a bit about the adventure and the battle against Flar’Melkhis. He says he’ll give the heroes’ report to Dirk’s guild and to The Roving Peers.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Some of the heroes are anxious to leave the big city and start seeking the next Shard of Concar. There is a portal in Bondōvriar to Freeburg.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes collected quite a haul of treasure from Flar’Melkhis’s lair, and decide to go spend some of it at Marifus Millgold’s Marvelous Magics. The heroes could use an additional bag of holding if nothing else.")
    }
}
